import { render, staticRenderFns } from "./showKnowledgeMes.vue?vue&type=template&id=3be887bf&scoped=true&"
import script from "./showKnowledgeMes.vue?vue&type=script&lang=js&"
export * from "./showKnowledgeMes.vue?vue&type=script&lang=js&"
import style0 from "./showKnowledgeMes.vue?vue&type=style&index=0&id=3be887bf&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be887bf",
  null
  
)

export default component.exports